import { Layout } from 'antd';
import NavBar from "../../components/NavBar";
import TransferRobotlistPSN from "../../components/robot/TransferRobotlistPSN";

const { Content } = Layout;

function TransferRobotPSN({ match }) {
   return (
      <Layout className="container main-layout">
         <NavBar />
         <Layout className="bg-gray">
            <Content className="layout-content">
               <TransferRobotlistPSN />
            </Content>
         </Layout>
      </Layout>
   );
}

export default TransferRobotPSN;
